import PropTypes from 'prop-types';
import React from 'react';
import { inputStyle, labelStyle } from './styles';

const Textarea = ({
  name,
  label,
  disabled,
  value,
  onChange,
  rows,
}) => (
  <>
    <label htmlFor={label} style={labelStyle}>
      <div>{label}</div>
      <textarea
        style={inputStyle}
        name={name}
        onChange={onChange}
        defaultValue={value}
        id={label}
        disabled={disabled}
        rows={rows}
      />
    </label>
  </>
);

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  rows: PropTypes.string,
};

Textarea.defaultProps = {
  value: '',
  disabled: false,
  rows: '6',
  label: '',
};

export default Textarea;
